import type { SecurityScanRecord } from "@hostdock/types";

/** Malicious + likely malicious files of a scan (false positives excluded); infectedCount for scans without counts. */
export const threats = (x?: SecurityScanRecord | null) => (x?.counts ? x.counts.malicious + x.counts.likelyMalicious : x?.infectedCount ?? 0);
/** Suspicious files a person should review. */
export const toReview = (x?: SecurityScanRecord | null) => x?.counts?.suspicious ?? 0;
export const plural = (n: number, w: string) => `${n} ${w}${n === 1 ? "" : "s"}`;

/** A one-line result of a finished scan: threats first, then files to review. */
export function scanResultLabel(x: SecurityScanRecord): { label: string; tone: "ok" | "bad" | "wait" } {
  const t = threats(x), r = toReview(x);
  if (t) return { label: `${plural(t, "threat")}${r ? ` · ${r} to review` : ""}`, tone: "bad" };
  if (r) return { label: `${plural(r, "file")} to review`, tone: "wait" };
  return { label: "No issues", tone: "ok" };
}
